import { FC, useRef,  } from 'react';
import { Box, Space, Accordion } from '@mantine/core';
import { useForm } from '@mantine/form';
import { TextInput, Checkbox ,Select } from '@common/components';
import { useTranslation } from 'react-i18next';
import { useFormFocus } from '@common/hooks';
import { Button } from '@common/components';
import styles from "./styles.module.scss"
import classNames from 'classnames';
import { ArrowLeft } from '@geist-ui/icons'

interface IScanPageProps{
    siteUrl: string;
    isScanFullWebsite: boolean;
    notifyBy: string;
    repeat: string;
    complianceLevel: string;
    engine: string;
}
const initialValues: IScanPageProps = {
    siteUrl: '',
    isScanFullWebsite: false,
    notifyBy: 'Notify by email',
    repeat: 'Never',
    complianceLevel: 'Complinace Level: AA',
    engine: 'Engine: WCAG-AA Ialabs',
};

const ScanPage: FC = (): JSX.Element => {
    const [t] = useTranslation('scanPage');
    const form = useForm({
        initialValues: initialValues,
    });
    const { setNeedFocus } = useFormFocus({ formErrors: form.errors });
    const errorRef = useRef<HTMLDivElement>(null);

    const onSubmitHandler = async (values: IScanPageProps): Promise<void> => {
        // console.log('Function not implemented.');
        
    };

    const onErrorHandler = (): void => {
        setNeedFocus(true);
    };

    function handleChange(arg0: string, e: string | null): void {
        // console.log('Function not implemented.');
    }

    const notifyny = ['Notify by email'];
    const repeat = ['Never'];
    const complinaceLevel = ['Complinace Level: AA'];
    const engines = ['Engine: WCAG-AA Ialabs'];




    return (


        <Box id="main-wrapper" className={styles.main_wrapper}>
             <div  aria-label={`${t('backbtn')}`}>
                <ArrowLeft/>
            </div>
            <Space h={'sm'} />
             <div className={styles.description} aria-label={`${t('newScan')}`}>
                {t('newScan')}
            </div>
            <Space h={'sm'} />

            <h1 id={'mainContent'} className={styles.title} tabIndex={-1}>
               {t('ScanWebsite')}
            </h1>
            <Space h={'sm'} />

            <div className={styles.description}>
                {t('description')}
            </div>
            <Space h={'xl'} />
            {onSubmitHandler && (
                <form className={styles.form} onSubmit={form?.onSubmit(onSubmitHandler, onErrorHandler)}>
                    <TextInput
                        className={styles.siteUriInput}
                        withAsterisk
                        label={`${t('yourSiteUrl')}`}
                        placeholder={`${t('siteUrl')}`}
                        ariaLabel={`${t('siteUrlDescribe')}`}
                        {...form.getInputProps('firstName')}
                    />
                    <Space h={'md'} />

                    <Checkbox
                        ariaLabel={`${t('scanFullSite')}`}
                        checked={form.values.isScanFullWebsite}
                        onChecked={(e) => form.setFieldValue('emailService', e.target.checked)}
                        label={`${t('scanFullSite')}`}
                        className={styles.scanFullSite}
                    />
                    <Space h={'md'} /> 

                    <Select
                        className={classNames(styles['select-styling'], {
                        })}
                        label ={`${t('notifyOnceComplete')}`}
                        variant="secondary"
                        withIcon
                        aria-label={`${t('notifyOnceComplete')}`}
                        value={form.values.notifyBy}
                        data={notifyny}
                        onChange={(e) => handleChange('byGroup', e)}
                    />
                    <Space h={'md'} />

                    <Select
                        className={classNames(styles['select-styling'], {
                        })}
                        label ={`${t('repeat')}`}
                        variant="secondary"
                        withIcon
                        aria-label={`${t('repeat')}`}
                        value={form.values.repeat}
                        data={repeat}
                        onChange={(e) => handleChange('byGroup', e)}
                    />
                    <Space h={'md'} />

                    <Accordion className={styles.accordion}>
                        <Accordion.Item value={t('advancedSettings')}>
                            <Accordion.Control>
                                {t('advancedSettings')}
                            </Accordion.Control>
                            <Accordion.Panel>
                                <Select
                                    className={classNames(styles['select-styling'], {
                                    })}
                                    label ={`${t('complianceLevel')}`}
                                    variant="secondary"
                                    withIcon
                                    aria-label={`${t('complianceLevel')}`}
                                    value={form.values.complianceLevel}
                                    data={complinaceLevel}
                                    onChange={(e) => handleChange('byGroup', e)}
                                />
                                <Space h={'md'} />
                                    <Select
                                    className={classNames(styles['select-styling'], {
                                    })}
                                    label ={`${t('engine')}`}
                                    variant="secondary"
                                    withIcon
                                    aria-label={`${t('engine')}`}
                                    value={form.values.engine}
                                    data={engines}
                                    onChange={(e) => handleChange('byGroup', e)}
                                />
                            </Accordion.Panel>
                        </Accordion.Item>
                    </Accordion>
                    <Space h={'xl'} />
                    <Button type={'submit'} aria-label={`${t('scanNow')}`} className={styles.scanBtn}>
                            {t('scanNow')}
                    </Button>
                   
                </form>
            )}
        
        </Box>

    );
};




export default ScanPage;
